import http from "../http"

export default class LeagueService
{
  static Active = async() => {
    return await http().get('League')
  }
}